"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.VARIANTS = exports.SELECTED_END_DATE = exports.FIRST_SELECTABLE_DAY = exports.FIRST_DAY_IN_MONTH = exports.CURRENT_DATE = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactDayPicker = _interopRequireDefault(require("react-day-picker"));

var _moment = _interopRequireWildcard(require("react-day-picker/moment"));

var _EDSContext = require("../EDSContext/EDSContext");

var _styles = _interopRequireDefault(require("../styles"));

var _Navbar = _interopRequireDefault(require("./internal/Navbar"));

var _Caption = _interopRequireDefault(require("./internal/Caption"));

var _DateUtils = require("./internal/DateUtils");

var _styles2 = _interopRequireDefault(require("./styles/styles"));

var _excluded = ["edsContext", "classes", "id", "format", "labels", "minDate", "maxDate", "numberOfMonths", "startYear", "endYear", "withMonthYearSelect"],
    _excluded2 = ["date", "localeUtils", "locale"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var VARIANTS = {
  DATE_PICKER: 'date-picker',
  DATE_RANGE_PICKER: 'date-range-picker'
};
exports.VARIANTS = VARIANTS;
var FIRST_SELECTABLE_DAY = '.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)';
exports.FIRST_SELECTABLE_DAY = FIRST_SELECTABLE_DAY;
var FIRST_DAY_IN_MONTH = '.DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)';
exports.FIRST_DAY_IN_MONTH = FIRST_DAY_IN_MONTH;
var CURRENT_DATE = '.DayPicker-Day--today:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)';
exports.CURRENT_DATE = CURRENT_DATE;
var SELECTED_END_DATE = '.DayPicker-Day--end:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)';
/**
 * DayPicker is a shared component by both DatePicker and DateRangePicker.
 * This component acts as a wrapper component of the original [react-day-picker](http://react-day-picker.js.org/) library.
 *
 * DP styles will always be applied, since they are the base of the DRP styles. While,
 *  DRP styles will be applied only when a variant prop is sent in.
 *  All input, container or other styles will stay in their own component specific files.
 *
 */

exports.SELECTED_END_DATE = SELECTED_END_DATE;

var DayPicker = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2.default)(DayPicker, _React$Component);

  function DayPicker(_props, context) {
    var _this;

    _this = _React$Component.call(this, _props, context) || this; // Function bindings

    _this.getInitialDate = function (props) {
      if (props === void 0) {
        props = _this.props;
      }

      var _props2 = props,
          defaultValue = _props2.defaultValue,
          value = _props2.value;

      if (value != null) {
        return value;
      } else if (defaultValue != null) {
        return defaultValue;
      } else {
        return null;
      }
    };

    _this.handleOnDayClick = _this.handleOnDayClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleYearMonthChange = _this.handleYearMonthChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = _this.initialState();
    return _this;
  } // ******
  // Initializations
  // ******


  var _proto = DayPicker.prototype;

  _proto.initialState = function initialState() {
    var value = this.getInitialDate();
    return {
      value: value,
      month: this.getInitialMonth()
    };
  };

  _proto.getInitialMonth = function getInitialMonth(props) {
    if (props === void 0) {
      props = this.props;
    }

    if (this.getInitialDate()) {
      // return current value
      return new Date(this.getInitialDate());
    } else if (this.props.initialMonth) {
      // return consumer's initialMonth to show
      return new Date(this.props.initialMonth);
    } else {
      // else return today's month
      return new Date();
    }
  } // ******
  // Lifecycle Methods
  // ******
  ;

  _proto.handleYearMonthChange = function handleYearMonthChange(month) {
    this.setState({
      month: month
    });
  };

  _proto.handleOnDayClick = function handleOnDayClick(day, modifiers, e) {
    if (modifiers === void 0) {
      modifiers = {};
    }

    // Disable users being able to click and enter day
    if (modifiers.disabled) {
      return;
    }

    if (this.props.onDayClick) {
      this.props.onDayClick(day, modifiers, e);
    }
  };

  _proto.render = function render() {
    var _cn,
        _this2 = this;

    var _this$props = this.props,
        edsContext = _this$props.edsContext,
        classes = _this$props.classes,
        idProp = _this$props.id,
        format = _this$props.format,
        labels = _this$props.labels,
        minDate = _this$props.minDate,
        maxDate = _this$props.maxDate,
        numberOfMonths = _this$props.numberOfMonths,
        startYear = _this$props.startYear,
        endYear = _this$props.endYear,
        withMonthYearSelect = _this$props.withMonthYearSelect,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded); // If no id is sent in, use uuid to make a unique one

    var id = idProp || this.uuid; // EDSApplication-level locale

    var locale = edsContext.locale;
    var dir = 'dir' in props ? props.dir : edsContext.dir;
    var buttonLabels = (0, _extends2.default)({
      previousMonth: edsContext.formatMessage('component.DayPicker.previousMonth'),
      nextMonth: edsContext.formatMessage('component.DayPicker.nextMonth')
    }, labels);
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: classes.root
    }, /*#__PURE__*/_react.default.createElement(_reactDayPicker.default, (0, _extends2.default)({
      className: (0, _classnames.default)('hedtech-DatePicker', // custom class name
      classes.DatePickerRoot, (_cn = {
        'hedtech-DateRangePicker': this.props.variant === VARIANTS.DATE_RANGE_PICKER
      }, _cn[classes.dateRangePickerRoot] = this.props.variant === VARIANTS.DATE_RANGE_PICKER, _cn[classes.singleMonth] = this.props.numberOfMonths === 1, _cn[classes.hideOutsideDays] = !this.props.showOutsideDays, _cn)),
      navbarElement: /*#__PURE__*/_react.default.createElement(_Navbar.default, {
        dir: dir,
        withMonthYearSelect: withMonthYearSelect
      }),
      labels: buttonLabels,
      captionElement: function captionElement(_ref) {
        var date = _ref.date,
            localeUtils = _ref.localeUtils,
            localeCaptionProp = _ref.locale,
            rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded2);
        return /*#__PURE__*/_react.default.createElement(_Caption.default, (0, _extends2.default)({
          onChange: _this2.handleYearMonthChange,
          date: date,
          localeUtils: _moment.default,
          locale: localeCaptionProp,
          dir: dir,
          withMonthYearSelect: withMonthYearSelect,
          minDate: minDate,
          maxDate: maxDate,
          startYear: startYear,
          endYear: endYear,
          id: id
        }, rest));
      },
      renderDay: function renderDay(day) {
        return (
          /*#__PURE__*/
          // We use a new div so we can apply our styles via custom class name
          _react.default.createElement("div", {
            "aria-hidden": "true",
            className: (0, _classnames.default)('hedtech-day', {
              'DayPicker-Today': props.highlightToday && (0, _DateUtils.isToday)(day)
            })
          }, day.toLocaleDateString(locale, {
            day: 'numeric'
          }))
        );
      },
      numberOfMonths: numberOfMonths,
      month: this.state.month,
      format: format,
      locale: locale,
      dir: dir,
      localeUtils: _moment.default,
      fromMonth: minDate,
      toMonth: maxDate
    }, props, {
      onDayClick: this.handleOnDayClick
    })));
  };

  return DayPicker;
}(_react.default.Component);

DayPicker.propTypes = {
  variant: _propTypes.default.oneOf([VARIANTS.DATE_RANGE_PICKER, VARIANTS.DATE_PICKER]),

  /**
   * @ignore
   * This function fetches resource string translations. It comes from the withEDSContext HOC.
   */
  edsContext: _propTypes.default.object,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  // Generic props

  /**
   * The id of the `input` element. This is also used to create id's for internal components such as the the `FormControl`, `InputLabel` and `DayPicker`.
   */
  id: _propTypes.default.string,

  /**
   * The format of the date to accept and display.
   *
   * e.g. `M/D/YYYY`, `MM-D-YY`, `l`, `LL`, `ll`.
   */
  format: _propTypes.default.string,

  /**
   * The date value for uncontrolled implementations.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.arrayOf(_propTypes.default.instanceOf(Date))]),

  /**
   * The maximum date possible to select. The selected date must fall in between the `minDate` and `maxDate`. Default is December 31st, 10 years in the future.
   */
  maxDate: _propTypes.default.any,

  /**
   * The minimum date possible to select. The selected date must fall in between the `minDate` and `maxDate`. Default is January 1st, 20 years in the past.
   */
  minDate: _propTypes.default.any,

  /**
   * Custom date function that parses the date. This is used to display date to the user in the input field.
   *
   * e.g.
   *
   * `(dateString: string, format: string, locale: string) => string`
   */
  parseDate: _propTypes.default.func,
  startYear: _propTypes.default.number,
  endYear: _propTypes.default.number,
  withMonthYearSelect: _propTypes.default.bool,
  // DayPicker props

  /**
   * The month to display in the calendar at first render. This differs from the `month` prop, as it won’t re-render the calendar if its value changes.
   */
  initialMonth: _propTypes.default.instanceOf(Date),

  /**
   * Labels to use as `aria-label` HTML attributes for the previous and next month navigation buttons.
   */
  labels: _propTypes.default.object,

  /**
   * **DEPRECATED** Will be determined by the props passed to [`EDSApplication`](#/components/EDSApplication).
   *
   * Render the `DatePicker` right-to-left.
   */
  dir: _propTypes.default.oneOf(['ltr', 'rtl']),

  /**
   * Object of functions to format dates and to get the first day of the week. You can pass your own object for advanced [localization](http://react-day-picker.js.org/docs/localization/).
   */
  localeUtils: _propTypes.default.object,

  /**
   * An object of *day modifiers*. This will add a new CSS class name on the days that match the modifier. [View react-day-picker documentation](http://react-day-picker.js.org/docs/matching-days/).
   *
   * e.g.
   * `const modifiers = { birthday: new Date(2018, 8, 19) } => // Creates a day component with the class name: .DayPicker-Day--birthday`
   */
  modifiers: _propTypes.default.object,

  /**
   * An object of inline styles added to the day cells when a modifier is matched. Use this prop to style day cells inline instead of using CSS classes.
   */
  modifiersStyles: _propTypes.default.object,

  /**
   * @ignore
   *
   * The month to display in the calendar. This differs from the `initialMonth` prop, as it causes the calendar to re-render when its value changes.
   */
  month: _propTypes.default.instanceOf(Date),

  /**
   * An array containing the long month names to use in the month’s header. Defaults to the English month names.
   */
  months: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * @ignore
   *
   * A React Element or React Component to render the navigation bar. It will receive the following props:
   *
   * - month: Date (The currently displayed month)
   * - previousMonth: Date
   * - nextMonth: Date
   * - onPreviousClick: () ⇒ void
   * - onNextClick: () ⇒ void
   */
  navbarElement: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * The number of months to render.
   *
   * We recommend this prop to be using sparingly. In some situations,
   * where only one month should be shown to conserve screen space or issues arise with the visual layout
   * of the DatePicker calendar interface. Most common situations are when the `DatePicker` is
   * placed in a `Dialog` or `Table`.
   */
  numberOfMonths: _propTypes.default.number,

  /**
   * @ignore
   *
   * When displaying multiple months, navigation will be paginated displaying the `numberOfMonths` at time instead of one.
   */
  pagedNavigation: _propTypes.default.bool,

  /**
   * @ignore
   *
   * Returns the content of a day cell. As default it returns day’s current date.
   */
  renderDay: _propTypes.default.oneOfType([_propTypes.default.elementType, _propTypes.default.func]),

  /**
   * @ignore
   *
   * Returns the content of the week element when showWeekNumbers is set. As default it returns the week number.
   */
  renderWeek: _propTypes.default.func,

  /**
   * **DEPRECATED** Will be determined by the props passed to [`EDSApplication`](#/components/EDSApplication).
   *
   * Render the months in reversed order. This prop should be used when `dir="rtl"`.
   */
  reverseMonths: _propTypes.default.bool,

  /**
   * Day(s) that should appear as selected.
   */
  selectedDays: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.object, _propTypes.default.func, _propTypes.default.array]),

  /**
   * Day(s) that should appear as disabled.
   */
  disabledDays: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.instanceOf(Date)), _propTypes.default.func]),

  /**
   * @ignore
   * Display the days falling outside the current month.
   */
  showOutsideDays: _propTypes.default.bool,

  /**
   * @ignore
   * Display the weekday names in the calendar header.
   */
  showWeekDays: _propTypes.default.bool,

  /**
   * @ignore
   * Display the year's week number next to each week.
   */
  showWeekNumbers: _propTypes.default.bool,

  /**
   * @ignore
   * Display a button to switch to the current month using the provided string as a label.
   */
  todayButton: _propTypes.default.bool,

  /**
   * @ignore
   *
   * A React Element or React Component to render the weekday cells in the header. It will receive the following props:
   *
   * - weekday `number`
   * - className `string`
   * - localeUtils `object`
   * - locale `string`
   */
  weekdayElement: _propTypes.default.instanceOf(Date),

  /**
   * @ignore
   *
   * An array containing the long weekdays names to use in the month's header Defaults to the English weekdays names. Must start from Sunday.
   */
  weekdaysLong: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * @ignore
   *
   * An array containing the short weekdays names to use in the month's header. Defaults to the English weekdays names. Must start from Sunday.
   */
  weekdaysShort: _propTypes.default.arrayOf(_propTypes.default.string),
  // DayPicker EventHandlers

  /**
   * @ignore
   */
  onCaptionClick: _propTypes.default.func,

  /**
   * @ignore
   *
   * Event handler when the user clicks on a day cell.
   *
   * e.g.
   * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
   */
  onDayClick: _propTypes.default.func,

  /**
   * Event handler when the day cell gets the `keydown` event.
   *
   * e.g.
   * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
   */
  onDayKeyDown: _propTypes.default.func,

  /**
   * Event handler when the day cell gets the `focus` event.
   *
   * e.g.
   * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
   */
  onDayFocus: _propTypes.default.func,

  /**
   * Event handler when the mouse button is pressed on a day cell.
   *
   * e.g.
   * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
   */
  onDayMouseDown: _propTypes.default.func,

  /**
   * @ignore
   * Event handler when the mouse enters a day cell.
   *
   * e.g.
   * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
   */
  onDayMouseEnter: _propTypes.default.func,

  /**
   * @ignore
   * Event handler when the mouse leave a day cell.
   *
   * e.g.
   * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
   */
  onDayMouseLeave: _propTypes.default.func,

  /**
   * Event handler when the mouse button is released on a day cell.
   *
   * e.g.
   * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
   */
  onDayMouseUp: _propTypes.default.func,

  /**
   * Event handler when the day cell gets the `touchStart` event.
   *
   * e.g.
   * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
   */
  onDayTouchStart: _propTypes.default.func,

  /**
   * Event handler when the day cell gets the `touchEnd` event.
   *
   * e.g.
   * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
   */
  onDayTouchEnd: _propTypes.default.func,

  /**
   * @ignore
   *
   * Event handler when the month is changed, i.e. clicking the navigation buttons or using the keyboard.
   *
   * e.g.
   * `(month: date) ⇒ void`
   */
  onMonthChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onWeekClick: _propTypes.default.func,

  /**
   * @ignore
   */
  onTodayButtonClick: _propTypes.default.func,
  // Public Methods

  /**
   * @ignore
   */
  showMonth: _propTypes.default.func,

  /**
   * @ignore
   */
  showPreviousMonth: _propTypes.default.func,

  /**
   * @ignore
   */
  showNextMonth: _propTypes.default.func,

  /**
   * @ignore
   */
  showPreviousYear: _propTypes.default.func,

  /**
   * @ignore
   */
  showNextYear: _propTypes.default.func,

  /**
   * Highlight today's date in the calendar.
   */
  highlightToday: _propTypes.default.bool
};
DayPicker.defaultProps = {
  initialMonth: new Date(),
  format: 'L',
  parseDate: _moment.parseDate,
  showOutsideDays: false,
  maxDate: (0, _DateUtils.getDefaultMaxDate)(),
  minDate: (0, _DateUtils.getDefaultMinDate)(),
  highlightToday: false
};

var _default = (0, _EDSContext.withEDSContext)((0, _styles.default)(_styles2.default)(DayPicker));

exports.default = _default;